module.exports = __webpack_public_path__ + "bdf815b63ed4a69c7674827f72411284.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/jones-sprite.png
// module id = NWKb
// module chunks = 0